import gql from 'graphql-tag';

import accountFragment from '../fragments/accountFragment';

export const mutationUpdateAccount = gql`
  mutation updateAccount (
    $name: String
    $slug: String
    $description: String
    $industry: AccountIndustry
    $useCase: AccountUseCase
    $attributionName: String
    $squareLogoID: DokkioID
    $rectangularLogoID: DokkioID
    $isOnboardingComplete: Boolean
    $onboardingChatMessage: String
    $autoCreateDokkioLabelConfidenceThreshold: Float
    $deletedAt: DateTime
  ) {
    updateAccount (
      name: $name
      slug: $slug
      description: $description
      industry: $industry
      useCase: $useCase
      attributionName: $attributionName
      squareLogoID: $squareLogoID
      rectangularLogoID: $rectangularLogoID
      isOnboardingComplete: $isOnboardingComplete
      onboardingChatMessage: $onboardingChatMessage
      autoCreateDokkioLabelConfidenceThreshold: $autoCreateDokkioLabelConfidenceThreshold
      deletedAt: $deletedAt
    ) {
      ...accountFragment
    }
  }
  ${accountFragment}
`;
export default mutationUpdateAccount;
